import { PublicClientApplication, BrowserCacheLocation } from "@azure/msal-browser";

const {
    REACT_APP_URL,
    REACT_APP_CLIENT_ID,
    REACT_APP_AUTHORITY,
    REACT_APP_KNOWN_AUTHORITIES,
    REACT_APP_READ_SCOPE,
    REACT_APP_WRITE_SCOPE
} = process.env;

const msalConfig = {
    auth: {
        authority: REACT_APP_AUTHORITY,
        clientId: REACT_APP_CLIENT_ID,
        redirectUri: REACT_APP_URL,
        knownAuthorities: [REACT_APP_KNOWN_AUTHORITIES],
        // Return to the original deep link after redirect sign-in (including new tabs).
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: false
    }
};

export const loginRequest = {
    scopes: ['openid', 'profile', REACT_APP_READ_SCOPE, REACT_APP_WRITE_SCOPE],
};

export const tokenRequest = {
    scopes: [REACT_APP_READ_SCOPE, REACT_APP_WRITE_SCOPE],
};

export const msalInstance = new PublicClientApplication(msalConfig);
